var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('b-container',{staticClass:"dashboard-container",attrs:{"fluid":"sm"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_vm._v(" Un segundo por favor ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }